import Missing from "./Missing";

export default Missing;
